import Colour from 'components/utils/Colour'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Group from 'components/utils/Group'
import { useAppSelector } from 'hooks/reduxHooks'
import { getThemeClassName } from 'lib/theme/themeUtils'
import TextButton from 'LuxKit/Button/TextButton'
import TextLink from 'LuxKit/TextLink'
import BodyText from 'LuxKit/Typography/BodyText'
import { getCanRedeemLuxPlusBenefits } from 'luxPlus/selectors/featureToggle'
import React from 'react'
import {
  LUX_PLUS_EXPERIENCE_DISCOUNT_ALL_OFFERS_URL,
  LUX_PLUS_EXPERIENCE_DISCOUNT_BECOME_MEMBER_URL,
} from '../constants/luxPlusExperienceDiscountTakeoverConstants'
import LuxPlusExperienceDiscountCalendarLogo from './LuxPlusExperienceDiscountCalendarLogo'
import { useShowExperienceDiscountBanner } from '../hooks/useShowExperienceDiscountBanner'

interface Props {
  withCta?: boolean
}

function LuxPlusExperienceDiscountOfferBanner({ withCta }: Props) {
  const shouldShow = useShowExperienceDiscountBanner()
  const isLuxPlusMember = useAppSelector(getCanRedeemLuxPlusBenefits)

  if (!shouldShow) {
    return null
  }

  const bannerCopy = 'members save more – 10% off all Experiences until 29 Dec when using promo code "EXP10LP" at checkout.'

  const ctaUrl = isLuxPlusMember ? LUX_PLUS_EXPERIENCE_DISCOUNT_ALL_OFFERS_URL : LUX_PLUS_EXPERIENCE_DISCOUNT_BECOME_MEMBER_URL
  const ctaText = isLuxPlusMember ? 'View offers' : 'Become a member'

  return <Group
    direction="horizontal"
    gap={12}
    verticalAlign="center"
    className={getThemeClassName({ mobile: 'inverse' })}
  >
    <LuxPlusExperienceDiscountCalendarLogo size="S" />
    <BodyText variant="large">
      <b>LuxPlus<Colour value="highlight-lux-plus">+</Colour></b> {bannerCopy}
      {withCta && (
        <CSSBreakpoint max="mobile">
          {' '}<TextLink to={ctaUrl} wrap="no-wrap">{ctaText}</TextLink>
        </CSSBreakpoint>
      )}
    </BodyText>
    {withCta && (
      <CSSBreakpoint min="tablet" className={getThemeClassName({ mobile: 'inverse' })}>
        <TextButton kind="secondary" size="small" to={ctaUrl}>
          {ctaText}
        </TextButton>
      </CSSBreakpoint>
    )}
  </Group>
}

export default LuxPlusExperienceDiscountOfferBanner
